// extracted by mini-css-extract-plugin
export var attachment = "_rn-a";
export var emailContainer = "_rn-4";
export var emailContentPaddedContainer = "_rn-b";
export var emailHeader = "_rn-6";
export var emailIframe = "_rn-3";
export var emailInfoIcon = "_rn-9";
export var emailShortenedSummary = "_rn-e";
export var infoDropdown = "_rn-0";
export var infoRowBoundedContent = "_rn-d";
export var internal = "_rn-5";
export var merchant = "_rn-8";
export var messageInputContainer = "_rn-h";
export var normal = "_rn-7";
export var replyCard = "_rn-f";
export var subtleButton = "_rn-1";
export var subtleButtonIconContainer = "_rn-2";
export var toggleViewRepliesButton = "_rn-c";
export var wrappingText = "_rn-g";